import React, { useContext, useState, useMemo, useRef } from 'react'
import ModalWindow from 'components/ModalWindow'
import { Button, Icon, Table } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { UserContext, NotifyContext } from 'context'

import api from 'actions/api'

import doRequest from 'actions/doRequest'
import dateUtils from 'utils/dateUtils'

const ApplicationApproveEditsModal = (props) => {
    const { application, closeParentModal, intl, reloadApp } = props

    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { pushNotify } = useContext(NotifyContext)
    const { logout } = useContext(UserContext)

    const abortRequestRef = useRef(null)

    const translates = useMemo(() => ({
        confirm: intl.formatMessage({ id: 'btn.confirm' }),
        confirmEdits: intl.formatMessage({ id: 'btn.confirmEdits' }),
        cancelApplication: intl.formatMessage({ id: 'btn.cancelApplication' }),
        carrierPhone: intl.formatMessage({ id: 'title.carrierPhone' }),
        applicationTitle: intl.formatMessage({ id: 'title.application' }),
        parameters: intl.formatMessage({ id: 'title.parameters' }),
        whenCreatingApplication: intl.formatMessage({ id: 'title.whenCreatingApplication' }),
        suggestedEdits: intl.formatMessage({ id: 'title.suggestedEdits' }),
        elevator: intl.formatMessage({ id: 'title.elevator' }),
        culture: intl.formatMessage({ id: 'title.culture' }),
        weight: intl.formatMessage({ id: 'title.weight' }),
        scheduledDate: intl.formatMessage({ id: 'title.scheduledDate' }),
        type: intl.formatMessage({ id: 'title.type' }),
        uploading: intl.formatMessage({ id: 'ordertype.uploading' }),
        unloading: intl.formatMessage({ id: 'ordertype.unloading' })
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const openModal = () => {
        setOpen(true)
    }

    const closeModal = () => {
        setOpen(false)
        closeParentModal()
    }

    const editApplication = (statusId) => {
        setLoading(true)

        const req = doRequest(api.applications.editApplication({ id: application.id, statusId }), pushNotify, logout)
        abortRequestRef.current = req.abort

        req.ready.then(data => {
            if (data) {
                pushNotify('success', 'title.success', 'msg.sendRequstSuccess', 2000)
            }
            reloadApp()
        }).catch((error) => {
            setLoading(false)
            closeModal()
        })

    }

    const getButtons = () => [
        { title: translates.confirmEdits, onClick: () => editApplication(3), disabled: loading, loading: loading },
        { title: translates.cancelApplication, onClick: () => editApplication(4), disabled: loading, loading: loading },
    ]

    const generateTableRow = (title, firstValue, secondValue) => {
        return (
            <Table.Row key={title + firstValue}>
                <Table.Cell className="applicationTitle"><b>{title}:</b></Table.Cell>
                <Table.Cell className="applicationValue">{firstValue}</Table.Cell>
                <Table.Cell className="applicationValue">{secondValue ? secondValue : firstValue}</Table.Cell>
            </Table.Row>
        )
    }

    return (
        <ModalWindow
            closeIcon
            iconType="info"
            title={translates.applicationTitle}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => openModal()}
            trigger={
                <Button className="actionButton" icon><Icon name="check circle" /><span>{translates.confirm}</span></Button>
            }
            actions={getButtons()}
        >
            <div className="applicationDetails">
                <Table basic="very" celled striped>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell textAlign='center'>{translates.parameters}</Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>{translates.whenCreatingApplication}</Table.HeaderCell>
                            <Table.HeaderCell textAlign='center'>{translates.suggestedEdits}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {generateTableRow(translates.elevator, application.elevator, application.newWarehouseName)}
                        {generateTableRow(translates.culture, intl.formatMessage({ id: `cultures.${application.nomenclature}` }), application.newNomenclatureName ? intl.formatMessage({ id: `cultures.${application.newNomenclatureName}` }) : null)}
                        {generateTableRow(translates.weight, application.weight, application.weightEdited)}
                        {generateTableRow(translates.scheduledDate, dateUtils.getDateFromString(application.scheduledDate), application.scheduledDateEdited && dateUtils.getDateFromString(application.scheduledDateEdited))}
                        {generateTableRow(translates.type, translates[application.departureType])}
                    </Table.Body>
                </Table>
            </div>
        </ModalWindow>
    )
}

export default injectIntl(ApplicationApproveEditsModal)